<div class="title">Verdieping</div>
<div class="d-flex">
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      [(ngModel)]="selectedFloorOption"
      (ngModelChange)="onSelectionChanged()"
      [disabled]="disabled"
      [compareWith]="compareOptions"
      placeholder="{{ placeholder }}"
    >
      <mat-option *ngFor="let option of floorOptions" [value]="option">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div
    class="left-fifteen-space"
    [ngClass]="
      selectedFloorOption == null || selectedFloorOption.value != null
        ? 'hidden'
        : ''
    "
  >
    <mat-form-field appearance="outline">
      <input
        #higherFloorInput
        matInput
        [(ngModel)]="inputValue"
        (ngModelChange)="onInputValueChanged()"
        [disabled]="disabled"
      />
    </mat-form-field>
  </div>
</div>
